module.exports = __webpack_public_path__ + "img/conf-tech.91ea996f.png";